import { OnboardingStart } from '../../../../models/Onboarding/OnboardingStart.js';

class Login {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  startFlow(provider) {
    let pathParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return this.apiClient.get(`v1/onboarding/login/${provider}${pathParam}`, {
      ...this.apiClient.withRequestContext()
    }).then(response => OnboardingStart.createFromResponse(response.data));
  }
  completeFlow(provider, data) {
    return this.apiClient.post(`v1/onboarding/login/${provider}`, data, {
      ...this.apiClient.withRequestContext()
    }).then(response => response.data);
  }
}

export { Login };
//# sourceMappingURL=Login.js.map
